import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Loader from "../../Loader/Loader";
import { suppressionModalStyles } from "./styles";

const SuppressionListsModal = ({ open, onClose, data, isLoading }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: suppressionModalStyles.dialogPaper,
      }}
    >
      <DialogTitle sx={suppressionModalStyles.dialogTitle}>
        <Typography variant="h6" sx={suppressionModalStyles.title}>
          Suppression List Prospects
        </Typography>
      </DialogTitle>

      <DialogContent sx={suppressionModalStyles.dialogContent}>
        {isLoading ? (
          <Box sx={suppressionModalStyles.loaderBox}>
            <Loader />
          </Box>
        ) : data && data.length > 0 ? (
          <TableContainer
            component={Paper}
            elevation={0}
            sx={suppressionModalStyles.tableContainer}
          >
            <Table sx={suppressionModalStyles.table}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ ...suppressionModalStyles.headerCell, ...suppressionModalStyles.emailHeaderCell }}>
                    Email
                  </TableCell>
                  <TableCell sx={{ ...suppressionModalStyles.headerCell, ...suppressionModalStyles.reasonHeaderCell }}>
                    Reason
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((item, index) => (
                  <TableRow 
                    key={index}
                    sx={suppressionModalStyles.tableRow}
                  >
                    <TableCell sx={{ ...suppressionModalStyles.bodyCell, ...suppressionModalStyles.emailBodyCell }}>
                      <Typography sx={suppressionModalStyles.emailText}>
                        {item.email || item.emails || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ ...suppressionModalStyles.bodyCell, ...suppressionModalStyles.reasonBodyCell }}>
                      <Typography sx={suppressionModalStyles.reasonText}>
                        {item.reason || "N/A"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box sx={suppressionModalStyles.emptyStateBox}>
            <Typography sx={suppressionModalStyles.emptyStateText}>
              No suppression lists found
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={suppressionModalStyles.dialogActions}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={suppressionModalStyles.closeButton}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuppressionListsModal;
